import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import homeSaga from "./homeSaga";
import itemSaga from "./itemSaga";
import alertsSaga from "./alertsSaga";
import adminRootSaga from "./Admin";

function* rootSaga() {
  yield all([authSaga(), homeSaga(), itemSaga(), alertsSaga(), adminRootSaga()]);
}
export default rootSaga;
